import { render, staticRenderFns } from "./EmatricaSalesPoints.vue?vue&type=template&id=c618c3c6&"
import script from "./EmatricaSalesPoints.vue?vue&type=script&lang=ts&"
export * from "./EmatricaSalesPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports